const legacyLinks = [
  {
    label: 'About Discover China Today',
    path: '/about/',
  },
  {
    label: 'Archives Overview',
    path: '/archives/',
  },
  {
    label: 'Archives: 2022',
    path: '/archives/2022/',
  },
  {
    label: 'Archives: October 2022',
    path: '/archives/2022/10/',
  },
  {
    label: 'Archives: November 2022',
    path: '/archives/2022/11/',
  },
  {
    label: 'Culture Category Hub',
    path: '/categories/Culture/',
  },
  {
    label: 'Chinese New Year Articles',
    path: '/categories/Culture/Chinese-New-Year/',
  },
  {
    label: 'Chinese Kung Fu Articles',
    path: '/categories/Culture/Chinese-Kung-Fu/',
  },
  {
    label: 'Chinese Zodiac Articles',
    path: '/categories/Culture/Chinese-Zodiac/',
  },
  {
    label: 'Chinese New Year Origins & Traditions',
    path: '/Culture/Chinese-New-Year/chinese-new-year-origin-and-traditions/',
  },
  {
    label: 'Top 3 Kung Fu Styles',
    path: '/Culture/Chinese-Kung-Fu/top3-kung-fu-styles/',
  },
  {
    label: 'Find My Chinese Zodiac Sign',
    path: '/Culture/Chinese-Zodiac/find-my-chinese-zodiac-sign/',
  },
];

export default legacyLinks;
